var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-tracking-spend-only-pane",domProps:{"innerHTML":_vm._s(_vm.timeSpent)}})}
var staticRenderFns = []

export { render, staticRenderFns }